import React, { useEffect, useState } from "react";
import styles from "./potential.module.css";
import { useDispatch, useSelector } from "react-redux";
import StarContainer from "../../components/star-container/star-container";
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import ScrollUpButton from "../../components/buttons/scroll-up-button/scroll-up-button";
import FilterSelect from "../../components/filter-select/filter-select";
import SearchBox from "../../components/search-box/search-box";
import PotentialRow from "../../components/potential/potential-row";
import { initPotentials, changeFilter } from "../../store/reducers/list/potentialList";
import { selectFilteredPotentials, selectPotentialFilter } from "../../store/selectors/potentialSelectors";
import { getUIText } from "../../translation";
import { LOCALES } from "../../constants";
import FILTERS from "../../config/filter_config.json";

export default function Potential() {
    const theme = useSelector((state) => state.theme.value);
    const lang = useSelector((state) => state.lang.value);
    const dispatch = useDispatch();

    const status = useSelector((state) => state.potentials.status);

    useEffect(() => {
        if (status === "idle") dispatch(initPotentials());
    }, [status, dispatch]);

    const [query, setQuery] = useState("");
    const potentialFilter = useSelector(selectPotentialFilter);
    const filteredPotentials = useSelector((state) => selectFilteredPotentials(state, query));

    return (
        <div id="container" data-theme={theme} data-lang={lang}>
            {theme === "dark" && <StarContainer />}
            <Header title={getUIText(lang, "header.title.potential")} />

            <div className={styles["potential-container"]}>
                <SearchBox changeQuery={setQuery} placeholder={getUIText(lang, "search.potential")} />
                <div className={styles["filter-wrapper"]}>
                    <FilterSelect
                        id={"potential_type"}
                        list={lang === LOCALES.KO ? FILTERS.POTENTIAL_TYPE : FILTERS.POTENTIAL_TYPE_ENG}
                        selected={potentialFilter.potential_type}
                        changeFilter={changeFilter}
                    />
                    <FilterSelect
                        id={"potential_role"}
                        list={lang === LOCALES.KO ? FILTERS.CLASS : FILTERS.CLASS_ENG}
                        selected={potentialFilter.potential_role}
                        changeFilter={changeFilter}
                    />
                </div>

                <div className={styles["potentials"]}>
                    {filteredPotentials.map((potential) => (
                        <PotentialRow lang={lang} potential={potential} key={potential.id} />
                    ))}
                </div>
            </div>

            <ScrollUpButton />
            <Footer />
        </div>
    );
}
